import '/assets/styles/main.pcss';

import header from './components/header.js';
import menu from './components/menu.js';
import slider from './components/slider.js';
import modal from './components/modal.js';
import jobForm from './components/jobForm.js';
import contactForm from './components/contactForm.js';
import manageThemeColor from './components/manageThemeColor.js';
import footerReveal from './components/footerReveal.js';
import didomi from './components/didomi.js';
import video from './components/video.js';

document.addEventListener('DOMContentLoaded', async () => {
  header();
  menu();
  slider();
  if (document.querySelectorAll('.project').length > 0) {
    const project = await import('./components/project.js');
    project.default();
  }
  if (document.querySelectorAll('.expertise .img-container').length > 0) {
    const stickerAnim = await import('./components/sticker-animation.js');
    stickerAnim.default();
  }
  modal();
  jobForm();
  contactForm();
  footerReveal();
  manageThemeColor();
  video();
});

didomi();

